import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSpace from 'eco-design/base/eco-space';
import useCardsShowHook from '../useHooks/useCardsShowHook';

const D_IMAGE_MAP: Record<string, { pc: string; pad: string; h5: string }> = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1768186914398/full-width-carousel.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1768186915199/Frame%202094654834.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1768186913129/Frame%202094654776.jpg',
    },
    au: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1786702781300-mwm37t-compressed-full-width-carousel.webp',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1786702801084-gdxfrl-compressed-Frame%202094655113.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1786702801084-gdxfrl-compressed-Frame%202094655113.webp',
    },
};

function TheComp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();
    const images = D_IMAGE_MAP[locale] || D_IMAGE_MAP.us;

    useCardsShowHook('.cost-saving-D', '.cost-saving-D');

    return (
        <section className={`cost-saving-D GtmModuleData-section`} id="cost-saving-D" data-section-id={'cost-saving-D'} data-section-title={t('D_title')}>
            <EcoSpace />
            <section
                className={`${css.section} cost-saving-D GtmModuleData-section`}
                id="cost-saving-D"
                data-section-id={'cost-saving-D'}
                data-section-title={t('D_title')}
            >
                <EcoImg className="img" pc={images.pc} pad={images.pad} h5={images.h5} isOpenLazy />
                <div className="D-info">
                    <div className="D-title">{t('D_title')}</div>
                    <div className="D-subtitle">{t('D_subtitle')}</div>
                    <div className="D-desc">{t('D_desc')}</div>
                </div>
            </section>
        </section>
    );
}

export default TheComp;
